import PageHeader from "@/components/PageHeader";

export function Privacy() {
  return (
    <div>
      <PageHeader overline="Legal" title="Privacy Policy" subtitle="How we collect, use, and protect your information." />
      <section className="max-w-3xl mx-auto px-5 sm:px-8 py-16 space-y-6 text-zinc-600 leading-relaxed">
        <p>Kenny Web Design ("we", "us") respects your privacy. This policy explains what data we collect and how we use it.</p>
        <h2 className="font-display text-2xl font-bold text-black tracking-tight pt-2">Information we collect</h2>
        <p>We collect information you provide via our contact and referral forms, including your name, business name, email, phone, and project details. We may also collect newsletter subscription emails.</p>
        <h2 className="font-display text-2xl font-bold text-black tracking-tight pt-2">How we use it</h2>
        <p>We use your information to respond to inquiries, deliver services, process referral rewards, and send updates you have opted into. We never sell your data.</p>
        <h2 className="font-display text-2xl font-bold text-black tracking-tight pt-2">Contact</h2>
        <p>Questions? Email us at hello@kennywebdesign.com.</p>
      </section>
    </div>
  );
}

export function Terms() {
  return (
    <div>
      <PageHeader overline="Legal" title="Terms of Service" subtitle="The terms governing the use of our website and services." />
      <section className="max-w-3xl mx-auto px-5 sm:px-8 py-16 space-y-6 text-zinc-600 leading-relaxed">
        <p>By using kennywebdesign.com you agree to these terms. Our services are provided under separate project agreements.</p>
        <h2 className="font-display text-2xl font-bold text-black tracking-tight pt-2">Referral program</h2>
        <p>Referral discounts require a valid, active referral code and verified proof of referral. Discounts are subject to availability and may be modified at any time.</p>
        <h2 className="font-display text-2xl font-bold text-black tracking-tight pt-2">Intellectual property</h2>
        <p>All content on this site is the property of Kenny Web Design unless otherwise noted.</p>
        <h2 className="font-display text-2xl font-bold text-black tracking-tight pt-2">Contact</h2>
        <p>Questions? Email us at hello@kennywebdesign.com.</p>
      </section>
    </div>
  );
}
